import variables from "@/styles/element-variables.scss";
import defaultSettings from "@/settings";
var showSettings = defaultSettings.showSettings,
  tagsView = defaultSettings.tagsView,
  fixedHeader = defaultSettings.fixedHeader,
  sidebarLogo = defaultSettings.sidebarLogo;
var state = {
  bg: "#ccccc",
  navBarBg: "",
  topNavSetBg: "#ff8850",
  topNavSetTextColor: "#333333",
  topNavTextColor: "#333333",
  leftNavBg: "#111744",
  leftNavTextColor: "#ffffff",
  leftNavSetBg: "#ff8850",
  theme: variables.theme,
  showSettings: showSettings,
  tagsView: tagsView,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo
};
var mutations = {
  CHANGE_SETTING: function CHANGE_SETTING(state, _ref) {
    var key = _ref.key,
      value = _ref.value;
    if (state.hasOwnProperty(key)) {
      state[key] = value;
    }
  }
};
var actions = {
  changeSetting: function changeSetting(_ref2, data) {
    var commit = _ref2.commit;
    commit("CHANGE_SETTING", data);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};